<template>
	<v-layout align-center>
		<v-flex align-center>
			<v-flex
				v-for="(item, index) in userStories.data"
				:key="index"
				class="no-text-dec list__tile--link mb-2"
				align-center
			>
				<v-card v-if="item.mediaType === mediaTypes.image" tile>
					<v-layout justify-center>
						<v-flex>
							<img
								class="white--text story-image"
								:src="item.mediaUrl"
							/>
						</v-flex>
					</v-layout>
					<v-card-title primary-title>
						<div>
							<h3 class="headline mb-0">
								{{ item.title }}
							</h3>
							<div>{{ item.description }}</div>
						</div>
					</v-card-title>
					<v-card-actions>
						<v-btn
							dark
							depressed
							:href="item.mediaUrl"
							target="_blank"
							:color="themeInputColor"
							class="btn white--text"
							@click="downloadUserStory(item)"
						>
							Download<v-icon>get_app</v-icon>
						</v-btn>
						<v-btn
							v-if="isRetailAdmin"
							dark
							depressed
							color="#ff0000"
							class="btn"
							@click.stop="deleteUserStory(item)"
							>Delete<v-icon>delete</v-icon></v-btn
						>
					</v-card-actions>
				</v-card>
				<v-card v-else tile>
					<iframe
						class="white--text"
						:src="embedUrl(item.mediaUrl)"
						width="100%"
						:height="screenProperties.iFrameHeight"
						frameborder="0"
						allowfullscreen
					></iframe>
					<v-card-title primary-title>
						<div>
							<h3 class="headline mb-0">
								{{ item.title }}
							</h3>
							<div>{{ item.description }}</div>
						</div>
					</v-card-title>
					<v-card-actions>
						<v-btn
							dark
							depressed
							:color="themeInputColor"
							class="btn white--text"
							@click="shareUserStory(item)"
							>Share<v-icon>share</v-icon></v-btn
						>
						<v-btn
							v-if="isRetailAdmin"
							dark
							depressed
							color="#ff0000"
							class="btn"
							@click.stop="deleteUserStory(item)"
							>Delete<v-icon>delete</v-icon></v-btn
						>
					</v-card-actions>
				</v-card>
			</v-flex>
		</v-flex>
	</v-layout>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { themeInputColor, shareOnWhatsapp } from "@/utils";
import EventsManager from "@/event-manager";

export default {
	mounted() {
		EventsManager.sendEvent({
			name: "USER_STORIES_VISITED"
		});
	},
	props: ["deleteUserStory"],
	data() {
		return {
			mediaTypes: {
				image: "IMAGE",
				video: "VIDEO"
			},
			themeInputColor
		};
	},
	computed: {
		...mapGetters({
			isRetailAdmin: "auth/isRetailAdmin"
		}),
		...mapState({
			userStories: state => state.jeet11.userStories
		}),
		embedUrl() {
			return value => {
				const url = new URL(value);
				const params = new URLSearchParams(url.search);
				const videoCode = params.get("v");
				return `https://www.youtube.com/embed/${videoCode}`;
			};
		},
		screenProperties() {
			switch (this.$vuetify.breakpoint.name) {
				case "xs":
					return { iFrameHeight: "200px", isMobileDevice: true };
				case "sm":
					return { iFrameHeight: "280px", isMobileDevice: false };
				case "md":
					return { iFrameHeight: "360px", isMobileDevice: false };
				case "lg":
					return { iFrameHeight: "400px", isMobileDevice: false };
				case "xl":
					return { iFrameHeight: "600px", isMobileDevice: false };
			}
		}
	},
	methods: {
		shareUserStory(item) {
			const linkToBeShared = item.mediaUrl;
			const textToBeShared =
				(item.title ? `${item.title}\n` : "") +
				(item.description ? `${item.description}\n` : "");
			shareOnWhatsapp(linkToBeShared, textToBeShared);
			EventsManager.sendEvent({
				name: "USER_STORIES_FEATURE_CLICKED",
				properties: {
					cityId: item.city,
					featureType: "USER_STORIES_SHARE_CLICKED"
				}
			});
		},
		downloadUserStory(item) {
			EventsManager.sendEvent({
				name: "USER_STORIES_FEATURE_CLICKED",
				properties: {
					cityId: item.city,
					featureType: "USER_STORIES_DOWNLOAD_CLICKED"
				}
			});
		}
	}
};
</script>

<style scoped lang="scss">
.story-image {
	display: block;
	margin: auto auto;
	max-width: 100%;
	max-height: 50vh;
}
</style>
